module.exports = __webpack_public_path__ + "img/foto_9.307c4bc1.png";